<template>
  <v-row class="my-0" :class="{standalone: !gallery}">
    <!-- full mode ( standalone page) -->
    <template v-if="!gallery">

      <v-responsive  :aspect-ratio="3589/1334" class="mb-8" width="100%" :max-width="$vuetify.breakpoint.mdAndUp ? '80%' : '100%'" >
        <v-row align="center" class="fill-height" no-gutters>
          <v-col cols="12" class="text-h4 text-md-h1 text-uppercase pa-8 pa-md-16 font-family-heading text-center">Suggested for You</v-col>
        </v-row>
      </v-responsive>
      <v-col cols="12" md="9" class="mx-md-auto">
        <talk-big-card v-for="talk in suggestedEvents" :key="talk.id" :list-data="talk" class="mb-8" />
      </v-col>
    </template>

    <!-- gallery mode-->
    <template v-if="gallery">
      <v-col cols="12"><h1 class="text-h2 mx-4">Suggested for You</h1></v-col>
      <v-col v-if="suggestedEvents.length > 0" class="px-4">
        <ScrollGallery
          :data="suggestedEvents"
          :cols="$vuetify.breakpoint.xl ? 3 : $vuetify.breakpoint.lgAndUp ? 4 : $vuetify.breakpoint.mdAndUp ? 5 : $vuetify.breakpoint.smAndUp ? 8 : 10" />
      </v-col>
      <v-col v-else cols="12">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="auto"><v-progress-circular indeterminate /></v-col>
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import ScrollGallery from '@/molecules/ScrollGallery'
// import ListWorkshopsByTopic from '@/graphql/ListWorkshopsByTopic.gql'
import ListTalksByTopic from '@/graphql/ListTalksByTopic.gql'
import uniqBy from 'lodash/uniqBy'
import intersectionBy from 'lodash/intersectionBy'
// import TalkCard from '@/molecules/TalkCard'
import TalkBigCard from '@/molecules/TalkBigCard.vue'

export default {
  name: 'SuggestedEvents',
  components: {
    ScrollGallery,
    // TalkCard,
    TalkBigCard
  },
  props: {
    gallery: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      suggestedEvents: []
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    interestsSort (a, b) {
      const aIntersection = intersectionBy(this.$root.databaseUser.topicsOfInterest, a.topics, 'id')
      const bIntersection = intersectionBy(this.$root.databaseUser.topicsOfInterest, b.topics, 'id')
      if (aIntersection.length > bIntersection.length) {
        return -1
      } else if (aIntersection.length < bIntersection.length) {
        return 1
      }
      // same number of shared interests between user and workshop/talk, we sort by time (earliest first)
      return new Date(a.startingAt).getTime() < new Date(b.startingAt).getTime() ? -1 : 1
    },
    fetchData () {
      for (let i = 0; i < this.$root.databaseUser.topicsOfInterest.length; i++) {
        const interest = this.$root.databaseUser.topicsOfInterest[i]
        // this is a loop, do not await
        this.$apollo.query({
          query: ListTalksByTopic,
          variables: {
            status: 'PUBLISHED',
            id: interest.id,
            sortOn: 'startingAt',
            descending: false
          }
        }).then(result => {
          const arr = uniqBy(this.suggestedEvents.concat(result.data.Talks._referents.TalkReferents.items), 'id')
          arr.sort(this.interestsSort)
          this.suggestedEvents = arr
          this.$root.$emit('scroll-to-saved-position')

          return null
        }).catch(e => console.error(e))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.standalone {
  background-image: url('../assets/img/suggested-bg.jpg');
  background-size: 100% auto;
  background-color: #0c80bd;
  background-repeat: no-repeat;
  background-position: 0 50px;
}
</style>
